import { apiCall } from '@/lib/api-client';
import type { LogCallAttemptInput } from '@/types/api';

export const callAttemptsApi = {
  log: (assignmentId: string, input: LogCallAttemptInput) =>
    apiCall<unknown>(`/assignments/${assignmentId}/attempts`, {
      method: 'POST',
      body: input,
    }),
};
